<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<!-- =========================================================
     PICKER VIEW — pick which system to manage
     ========================================================= -->
<ng-container *ngIf="!selectedSystem">
  <section class="picker-hero">
    <div class="picker-hero-bg"></div>
    <div class="picker-hero-content">
      <div class="eyebrow">
        <i class="pi pi-shield"></i>
        <span>إدارة الصلاحيات</span>
      </div>
      <h1 class="title">اختر نظاماً لإدارة صلاحياته</h1>
      <p class="sub">
        كل نظام له كاتالوج صلاحيات مستقل. ابدأ بالنظام الذي تريد تعديل صلاحياته،
        ثم تنقّل بين موارده بمرونة.
      </p>
    </div>
  </section>

  <div class="picker-skeleton" *ngIf="loading">
    <div class="sys-skel" *ngFor="let i of [1,2,3,4,5,6]"></div>
  </div>

  <div class="systems-grid" *ngIf="!loading">
    <button
      type="button"
      class="sys-card"
      [class]="card.themeClass"
      [class.is-empty]="card.total === 0"
      *ngFor="let card of systemCards; trackBy: trackCard"
      (click)="selectSystem(card)"
    >
      <div class="sys-card-head">
        <div class="sys-icon">
          <i [class]="card.icon"></i>
        </div>
        <div class="sys-meta">
          <h3 class="sys-name">{{ card.system.displayName }}</h3>
          <code class="sys-key">{{ card.system.key }}</code>
        </div>
      </div>

      <div class="sys-stats">
        <div class="sys-stat">
          <span class="num">{{ card.total }}</span>
          <span class="lbl">صلاحية</span>
        </div>
        <span class="dot" aria-hidden="true"></span>
        <div class="sys-stat">
          <span class="num">{{ card.resources }}</span>
          <span class="lbl">مورد</span>
        </div>
        <span class="dot" aria-hidden="true" *ngIf="card.inactive > 0"></span>
        <div class="sys-stat sys-stat--warn" *ngIf="card.inactive > 0">
          <span class="num">{{ card.inactive }}</span>
          <span class="lbl">غير نشطة</span>
        </div>
      </div>

      <div class="sys-resources" *ngIf="card.topResources.length > 0">
        <span class="res-pill" *ngFor="let r of card.topResources">{{ r }}</span>
      </div>

      <div class="sys-empty" *ngIf="card.total === 0">
        <i class="pi pi-inbox"></i>
        <span>لا توجد صلاحيات مُسجَّلة</span>
      </div>

      <div class="sys-cta">
        <span>{{ card.total === 0 ? 'أضف صلاحيات' : 'إدارة الصلاحيات' }}</span>
        <i class="pi pi-arrow-left"></i>
      </div>
    </button>

    <div class="picker-empty" *ngIf="systemCards.length === 0">
      <div class="empty-illust"><i class="pi pi-th-large"></i></div>
      <h3>لا توجد أنظمة متاحة</h3>
      <p>لا يوجد لديك صلاحية على أي نظام لإدارة صلاحياته.</p>
    </div>
  </div>
</ng-container>

<!-- =========================================================
     DETAIL VIEW — manage selected system
     ========================================================= -->
<ng-container *ngIf="selectedSystem">
  <section class="detail-hero">
    <button type="button" class="back-btn" (click)="backToPicker()">
      <i class="pi pi-arrow-right"></i>
      <span>كل الأنظمة</span>
    </button>

    <div class="detail-hero-main">
      <div class="detail-icon">
        <i [class]="currentSystemIcon"></i>
      </div>
      <div class="detail-text">
        <div class="eyebrow eyebrow-light">
          <i class="pi pi-shield"></i>
          <span>صلاحيات النظام</span>
        </div>
        <h1 class="detail-title">{{ selectedSystem.displayName }}</h1>
        <code class="detail-key">{{ selectedSystem.key }}</code>
      </div>
    </div>

    <div class="detail-stats">
      <div class="d-stat">
        <span class="d-stat-num">{{ currentTotal }}</span>
        <span class="d-stat-lbl">إجمالي</span>
      </div>
      <div class="d-stat d-stat--success">
        <span class="d-stat-num">{{ currentActive }}</span>
        <span class="d-stat-lbl">نشطة</span>
      </div>
      <div class="d-stat d-stat--warn" *ngIf="currentInactive > 0">
        <span class="d-stat-num">{{ currentInactive }}</span>
        <span class="d-stat-lbl">غير نشطة</span>
      </div>
      <div class="d-stat d-stat--info">
        <span class="d-stat-num">{{ currentResources }}</span>
        <span class="d-stat-lbl">مورد</span>
      </div>
    </div>
  </section>

  <div class="toolbar">
    <div class="filters">
      <span class="p-input-icon-left search-wrap">
        <i class="pi pi-search"></i>
        <input
          pInputText
          [(ngModel)]="filter.search"
          placeholder="ابحث في Code أو الاسم..."
          (input)="applyFilters()"
        />
      </span>
      <button
        *ngIf="filter.search"
        pButton
        icon="pi pi-filter-slash"
        label="مسح"
        class="p-button-text btn-clear"
        (click)="clearFilters()"
      ></button>
    </div>

    <div class="actions-bar">
      <button
        pButton
        label="فتح الكل"
        icon="pi pi-angle-double-down"
        class="p-button-text"
        (click)="expandAll()"
      ></button>
      <button
        pButton
        label="طي الكل"
        icon="pi pi-angle-double-up"
        class="p-button-text"
        (click)="collapseAll()"
      ></button>
    </div>
  </div>

  <div class="groups-list">
    <div class="group-card" *ngFor="let g of groups; trackBy: trackGroup" [class.is-open]="g.expanded">
      <div class="group-header" (click)="g.expanded = !g.expanded">
        <div class="group-icon">
          <i [class]="g.icon"></i>
        </div>
        <div class="group-meta">
          <div class="group-title-row">
            <span class="res-name">{{ g.label }}</span>
            <code class="res-code">{{ g.resource }}</code>
          </div>
          <div class="group-verbs">
            <span
              class="verb-mini"
              *ngFor="let p of g.permissions; trackBy: trackPerm"
              [ngClass]="verbTone(p)"
              [pTooltip]="p.displayNameAr || p.displayNameEn || (p.systemKey + ':' + p.code)"
              tooltipPosition="top"
            >
              {{ actionOf(p) || '·' }}
            </span>
          </div>
        </div>
        <div class="group-side">
          <span class="count-badge">{{ g.permissions.length }}</span>
          <i class="pi chevron" [class.pi-chevron-up]="g.expanded" [class.pi-chevron-down]="!g.expanded"></i>
        </div>
      </div>

      <div class="group-body" *ngIf="g.expanded">
        <table class="inner-table">
          <thead>
            <tr>
              <th style="width: 130px">الفعل</th>
              <th>المفتاح الكامل</th>
              <th>الاسم (عربي)</th>
              <th>الاسم (إنجليزي)</th>
              <th style="width: 110px">الحالة</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of g.permissions; trackBy: trackPerm">
              <td>
                <span class="verb-chip" [ngClass]="verbTone(p)">{{ actionOf(p) || '·' }}</span>
              </td>
              <td><code class="mono">{{ p.systemKey }}:{{ p.code }}</code></td>
              <td>{{ p.displayNameAr || '—' }}</td>
              <td>{{ p.displayNameEn || '—' }}</td>
              <td>
                <span
                  class="chip"
                  [class.chip--success]="p.isActive !== false"
                  [class.chip--danger]="p.isActive === false"
                >
                  <i class="pi" [class.pi-check-circle]="p.isActive !== false" [class.pi-times-circle]="p.isActive === false"></i>
                  {{ p.isActive !== false ? 'نشط' : 'غير نشط' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="empty-state" *ngIf="groups.length === 0">
      <div class="empty-illust">
        <i class="pi pi-inbox"></i>
      </div>
      <h3>لا توجد نتائج</h3>
      <p>جرّب تعديل البحث أو امسحه لعرض كل صلاحيات هذا النظام.</p>
    </div>
  </div>
</ng-container>
